import { isBrowser } from '@/utils/environment';
import type ProductLink from '@gik/blog/models/ProductLink';
import { Breakpoint, useBreakpoint } from '@gik/core/hooks/hooks/BreakpointHooks';
import { CheckoutType } from '@gik/core/models/gik/Product';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { Carousel } from '@gik/ui/Carousel';
import { ProductTile } from '@gik/ui/gik/ProductTile';
import React from 'react';
import type { Settings } from 'react-slick';

export interface IProductCarouselProps {
  productLinks: ProductLink[];
  title: string;
}

const blockName = 'product-carousel';

export function ProductCarousel({ productLinks, title }: IProductCarouselProps) {
  const bem = useBemCN(blockName);

  const isLg = useBreakpoint(Breakpoint.LG);
  const [slidesToShow, setSlidesToShow] = React.useState<number>(4);

  React.useEffect(() => {
    if (isBrowser()) {
      setSlidesToShow(isLg ? 3 : window.innerWidth / 220);
    }
  }, [isLg]);

  const settings: Settings = {
    slidesToShow,
    infinite: false,
    autoplay: false,
    speed: 750,
    slidesToScroll: 1,
  };

  return (
    <div {...bem()}>
      <p className="title">{title}</p>
      <Carousel {...settings}>
        {productLinks.map(productLink => (
          <ProductTile
            key={productLink.slug}
            title={productLink.title}
            href={'/products/' + productLink.slug}
            imageUrl={productLink.smallImageUrl}
            containImage={
              productLink.checkoutType === CheckoutType.TangoCard ||
              productLink.checkoutType === CheckoutType.Perfectgift
            }
            direction="column"
          />
        ))}
      </Carousel>
    </div>
  );
}
